import { typesenseApiClient, type TypesenseParams } from '$lib/api/typesenseApi';
import { SearchClient } from 'typesense';
import { PUBLIC_TYPESENSE_API_KEY, PUBLIC_TYPESENSE_URL } from '$env/static/public';
import type { SearchParams, SearchResponse } from 'typesense/lib/Typesense/Documents';
import type { SearchOnlyCollection } from 'typesense/lib/Typesense/SearchOnlyCollection';
import type { Collections, CollectionType } from '$lib/api/types/typesenseApiTypes';

export class SearchApi {
    private static readonly searchClient = new SearchClient({
        apiKey: PUBLIC_TYPESENSE_API_KEY,
        nodes: [{ url: PUBLIC_TYPESENSE_URL }]
    });

    public static search<C extends Collections>(
        collection: C,
        params: SearchParams,
        abortSignal: AbortSignal
    ): Promise<SearchResponse<CollectionType<C>>> {
        return (SearchApi.searchClient.collections(collection) as SearchOnlyCollection<CollectionType<C>>)
            .documents()
            .search(params, { cacheSearchResultsForSeconds: 0, abortSignal });
    }

    public static multiSearch(params: TypesenseParams | undefined) {
        return typesenseApiClient.invoke('multi_search', params ?? ({ q: '*' } as TypesenseParams), {});
    }
}
